import { ReactElement } from "react";

import { QueryAction } from "../api";
import QueryActionForm from "./QueryActionForm";

type Props = {
  queryAction: QueryAction;
};

export const QueryActionEdit = ({ queryAction }: Props): ReactElement => {
  return (
    <QueryActionForm
      integration={{
        baseUrl: queryAction.baseUrl,
        id: queryAction.integrationId,
        name: queryAction.integrationName,
        type: queryAction.integrationType,
      }}
      queryAction={queryAction}
    />
  );
};
